/***************************************************************************/
"use client";
/***************************************************************************/

import {
  AlertTriangle,
  CheckCircle,
  CircleAlert,
  Megaphone,
  Siren,
} from "lucide-react";

const ToastDefaultIcon = Megaphone;

const ToastSuccessIcon = CheckCircle;

const ToastInfoIcon = CircleAlert;

const ToastWarningIcon = Siren;

const ToastDangerIcon = AlertTriangle;

export {
  ToastDangerIcon,
  ToastDefaultIcon,
  ToastInfoIcon,
  ToastSuccessIcon,
  ToastWarningIcon,
};
